// @flow
import types from "./types";
import type {StopRequest} from "./utils";
import type {LatLngLiteral} from "../../../Utils/MapUtils";

const selectOrigin = (origin: StopRequest) => ({
    type: types.REQUEST_ORIGIN_SET,
    payload: origin,
});

const selectDest = (dest: StopRequest) => ({
    type: types.REQUEST_DEST_SET,
    payload: dest,
});

const selectOriginSuggestion = (origin: Object) => ({
    type: types.ORIGIN_SUGGESTION_SET,
    payload: origin,
});
const selectDestSuggestion = (dest: Object) => ({
    type: types.DEST_SUGGESTION_SET,
    payload: dest,
});

const clickOriginLabel = () => ({type: types.ORIGIN_LABEL_CLICK});
const clickDestLabel = () => ({type: types.DEST_LABEL_CLICK});
const cancelSearchClick = () => ({type: types.CANCEL_SEARCH_CLICK});
const updateOriginLatlng = (latlng: LatLngLiteral) => ({type: types.ORIGIN_LATLNG_SET, payload: latlng});
const updateDestLatlng = (latlng: LatLngLiteral) => ({type: types.DEST_LATLNG_SET, payload: latlng});
const updateOriginAddress = (address: string) => ({type: types.ORIGIN_ADDRESS_SET, payload: address});
const updateDestAddress = (address: string) => ({type: types.DEST_ADDRESS_SET, payload: address});
const invalidateDest = () => ({type: types.DEST_DESELECT});
const invalidateOrigin = () => ({type: types.ORIGIN_DESELECT});
const cancelOriginTerminalSelectionClick = () => ({type: types.CANCEL_ORIGIN_TERMINALS_CLICK});
const cancelDestTerminalSelectionClick = () => ({type: types.CANCEL_DEST_TERMINALS_CLICK});

export default {
    selectOrigin,
    selectDest,
    selectOriginSuggestion,
    selectDestSuggestion,
    clickOriginLabel,
    clickDestLabel,
    cancelSearchClick,
    updateOriginLatlng,
    updateDestLatlng,
    updateOriginAddress,
    updateDestAddress,
    invalidateDest,
    invalidateOrigin,
    cancelOriginTerminalSelectionClick,
    cancelDestTerminalSelectionClick,
};



// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentRequest/actions.js